import React, { useEffect, useState, useCallback } from 'react';
import config from '../../../config/config'
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2'; // Import SweetAlert2

function BannerList(props) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      const result = await config.getAllBanners();
      setUsers(result.data || []);
      setError(null);
    } catch (err) {
      setUsers([]);
      setError(null); // Silently fail
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleEdit = async (bannerId) => {
    try {
      // SweetAlert2 Confirmation Dialog
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You want to edit this user!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No',
      });
  
      if (result.isConfirmed) {
        window.location.href = `editBanner/${bannerId}`;
  
      }
    } catch (err) {
      // Error message if the API call fails
      Swal.fire('Error!', 'There was an issue editing the user.', 'error');
    }
  };
  
  const handleRemove = async (bannerId) => {
    try {
      // SweetAlert2 Confirmation Dialog
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this user!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No',
      });
  
      if (result.isConfirmed) {
        // If the user confirms the action, proceed with the API call
        await config.removeUser({'id':bannerId}); // Call the remove API
        fetchUsers(); // Re-fetch users after deletion
  
        // Success message after API call
        // Swal.fire('Deleted!', 'The user has been deleted successfully.', 'success');
      }
    } catch (err) {
      // Error message if the API call fails
      Swal.fire('Error!', 'There was an issue removing the user.', 'error');
    }
  };
  
  // const userData = users.map((user, index) => ({ ...user, id: index + 1 }));
  const userData = users.map((user, index) => ({ ...user, serialNo: index + 1 }));
  const columns = [
    { name: '#', selector: row => row._id, sortable: true, width: '60px' },
    { name: 'Page', selector: row => row.page, sortable: true, minWidth: '80px' },
    { name: 'Title', selector: row => row.title, minWidth: '120px' },
    { name: 'Description', selector: row => row.description, minWidth: '150px', omit: true },
    {
      name: 'Actions',
      button: true,
      width: '150px',
      cell: row => (
        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
          <button
            onClick={() => handleEdit(row._id)}
            className="btn btn-warning btn-sm"
            style={{ padding: '0.25rem 0.5rem', fontSize: '11px' }}
          >
            Edit
          </button>
          <button
            onClick={() => handleRemove(row._id)}
            className="btn btn-danger btn-sm"
            style={{ padding: '0.25rem 0.5rem', fontSize: '11px' }}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const paginationOptions = {
    rowsPerPageText: 'Rows per page:',
    rangeSeparatorText: 'of',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All',
  };

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        fontSize: '13px',
        fontWeight: '600',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        fontSize: '12px',
      },
    },
  };

  return (
    <div className="page-inner">
      <div className="page-header">
        <h3 className="fw-bold mb-3">Users</h3>
        <ul className="breadcrumbs mb-3">
          <li className="nav-home"><a href="#"><i className="fas fa-users"></i></a></li>
          <li className="separator"><i className="fa-solid fa-greater-than"></i></li>
          <li className="nav-item"><a href="#">Users</a></li>
        </ul>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="card-title">
                <a href="/admin/banner/addUpdateBanner" className="btn btn-primary">
                  <i className="fas fa-plus"></i> Add Baneer
                </a>
              </div>
            </div>

            <div className="card-body">
              {loading ? (
                <div>Loading banners...</div>
              ) : (
                <DataTable
                  columns={columns}
                  data={userData}
                  pagination
                  paginationComponentOptions={paginationOptions}
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 50]}
                  striped
                  highlightOnHover
                  responsive
                  customStyles={customStyles}
                  noDataComponent={<div style={{padding: '20px'}}>No banners available</div>}
                />
              )}
            </div>

            <div className="card-action"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerList;
